import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Navigate, useNavigate, Link } from "react-router-dom";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="p-8 text-muted-foreground">Cargando…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const { ok, error: err } = await login(email, password);
    setBusy(false);
    if (ok) navigate("/admin");
    else setError(err || "No se pudo iniciar sesión");
  };

  return (
    <div className="min-h-screen grid place-items-center bg-accent/30 p-4" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-border p-8 shadow-sm">
        <Link to="/" className="inline-flex items-center gap-2 mb-6" data-testid="login-brand">
          <div className="h-9 w-9 rounded-full bg-primary grid place-items-center text-primary-foreground font-black">C</div>
          <div>
            <div className="font-display font-black">Casa del Pueblo</div>
            <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Panel interno</div>
          </div>
        </Link>
        <h1 className="font-display font-black text-2xl">Acceso staff</h1>
        <p className="text-sm text-muted-foreground mt-1">Introduce tus credenciales.</p>

        <form onSubmit={submit} className="space-y-4 mt-6" data-testid="login-form">
          <div>
            <label className="block text-sm font-bold mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full rounded-xl border border-border bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-ring"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="block text-sm font-bold mb-1">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full rounded-xl border border-border bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-ring"
              data-testid="login-password"
            />
          </div>
          {error && (
            <div className="text-sm text-destructive bg-destructive/10 border border-destructive/30 rounded-lg px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-primary text-primary-foreground py-3 rounded-full font-bold hover:brightness-110 disabled:opacity-60 transition"
            data-testid="login-submit-btn"
          >
            {busy ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
